import { getTermsValue } from '@/packages/JsonQuery';
import { EGarageType } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagGarageTypeSchema } from '../types';

const TEXT_MAP: { [key in EGarageType]: string | null } = {
  [EGarageType.Any]: null,
  [EGarageType.Garage]: 'Гараж',
  [EGarageType.CarPlace]: 'Машиноместо',
  [EGarageType.Box]: 'Бокс',
};

export const garageType: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value: EGarageType[] = getTermsValue('garage_type')(jsonQuery) || [];

    const tagsGroup = value.reduce<TagGarageTypeSchema[]>((acc, key) => {
      const text = TEXT_MAP[key];
      if (!text) {
        return acc;
      }

      acc.push({
        group: 'garageType',
        text,
        data: key,
      });

      return acc;
    }, []);

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagGarageTypeSchema) {
    const currentValue = getTermsValue('garage_type')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setGarageTypes',
      arguments: [nextValue],
    });
  },
};
